import { createI18n } from "vue-i18n";
import localePtBR from "./locales/pt-BR.json";
import localeEn from "./locales/en.json";
export const i18n = createI18n({
  locale: process.env.VUE_APP_LOCALE || "pt-BR",
  fallbackLocale: "en",
  messages: {
    "pt-BR": localePtBR,
    en: localeEn,
  },
});
